import { lazy } from 'react';

import type { TabCaiDat } from '../../lib/caiDatTabs.js';

/** Mục "Công ty" của trang Cài đặt — xem `lib/caiDatTabs.ts`. */
const caiDatTabs: TabCaiDat[] = [
  {
    id: 'cong-ty',
    label: 'Công ty',
    phu: 'Bên A của biên bản và hai tham số thuế TNCN',
    giaiThich:
      'Sửa ở đây không làm đổi biên bản đã chốt: lúc chốt, khối Bên A và tham số thuế được chụp vào chính dòng phiên bản đó.',
    order: 10,
    permission: { module: 'team', level: 'admin' },
    component: lazy(() =>
      import('./components/TabCongTy.js').then((m) => ({ default: m.TabCongTy })),
    ),
  },
];

export default caiDatTabs;
